import React, { useState } from "react";
import { Card, CardContent } from "@material-ui/core";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import styles from "../Accounts.module.scss";

const TipsCard = () => {
  return (
    <Card className={`${styles.tipsCard} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
      <div className={styles.cardHeader}>
        <div className={styles.iconContainer}>
          <span className={styles.iconClock}><AccessTimeIcon /></span>
        </div>
        <div>
          <h2 className={`${styles.cardTitle} dark:text-white`}>Tips for Efficient Scheduling</h2>
          {/* <p className={styles.cardDescription}>Make the most of your appointment settings</p> */}
        </div>
      </div>
      <CardContent className="pt-0">
        <ul className={styles.tipsList}>
          <li>
            <span className={styles.iconCheck}><CheckCircleOutlineIcon  fontSize="small"/></span>
            <span className="dark:text-white">Employees will need to enable location services on their device</span>
          </li>
          <li>
            <span className={styles.iconCheck}><CheckCircleOutlineIcon  fontSize="small"/></span>
            <span className="dark:text-white">GPS accuracy may vary based on device and environmental conditions</span>
          </li>
          <li>
            <span className={styles.iconCheck}><CheckCircleOutlineIcon fontSize="small"/></span>
            <span className="dark:text-white">Consider a larger radius for areas with poor GPS signal</span>
          </li>
          <li>
            <span className={styles.iconCheck}><CheckCircleOutlineIcon fontSize="small"/></span>
            <span className="dark:text-white">Some employees may need assistance if they're having location issues</span>
          </li>
        </ul>
      </CardContent>
    </Card>
  );
};
  
export default TipsCard;


export function SettingsSummary ({ schedulingSystem, workWeek, startTime, endTime, overlapping, timeFormat, earlyCheckIn, timeInterval, standardWorkTime, geoFencingStatus, measurementUnit, geoFencingRadius}) {
    const [isExpanded, setIsExpanded] = useState(true);
    const toggleExpand = () => setIsExpanded(!isExpanded);
  
    return (
      <Card className={`${styles.summaryCard} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}>
        <div className={`${styles.summaryCardHeader} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`} onClick={toggleExpand}>
          <div className={styles.summaryCardHeaderContent}>
            <span className={`${styles.summaryCardTitle} dark:text-white`}>Settings Summary</span>
            {isExpanded ? (
              <KeyboardArrowUpIcon className={styles.summaryCardIcon} />
            ) : (
              <KeyboardArrowDownIcon className={styles.summaryCardIcon} />
            )}
          </div>
        </div>
  
        {isExpanded && (
          <CardContent className={styles.summaryCardContent}>
            <div className={styles.field}>
              <span className={styles.labels}>Scheduling System:</span>
              <span className={`${styles.value} dark:text-white`}>{schedulingSystem}</span>
            </div>
            <div className={styles.field}>
              <span className={styles.labels}>Time Format:</span>
              <span className={`${styles.value} dark:text-white`}>{timeFormat}</span>
            </div>
            <div className={styles.field}>
              <span className={styles.labels}>Work Days:</span>
              <span className={`${styles.value} dark:text-white`}>{workWeek?.join(", ")}</span>
            </div>
            <div className={styles.field}>
              <span className={styles.labels}>Time Interval:</span>
              <span className={`${styles.value} dark:text-white`}>{timeInterval}</span>
            </div>
            <div className={styles.field}>
              <span className={styles.labels}>Standard Start Time:</span>
              <span className={`${styles.value} dark:text-white`}>{startTime}</span>
            </div>
            <div className={styles.field}>
              <span className={styles.labels}>Standard End Time:</span>
              <span className={`${styles.value} dark:text-white`}>{endTime}</span>
            </div>
            <div className={styles.field}>
              <span className={styles.labels}>Allow Overlapping Bookings:</span>
              <span className={`${styles.value} dark:text-white`}>{overlapping}</span>
            </div>
            <div className={styles.field}>
              <span className={styles.labels}>Non-Standard Hours:</span>
              <span className={`${styles.value} dark:text-white`}>{standardWorkTime}</span>
            </div>
            <div className={styles.field}>
              <span className={styles.labels}>Early Check-In:</span>
              <span className={`${styles.value} dark:text-white`}>{earlyCheckIn}</span>
            </div>
            <div className={styles.field}>
              <span className={styles.labels}>Geo Fencing Status</span>
              <span className={`${styles.value} dark:text-white`}>{geoFencingStatus}</span>
            </div>
            {geoFencingStatus === "Enabled" && (
              <>
              <div className={styles.field}>
                <span className={styles.labels}>Measurement Unit</span>
                <span className={`${styles.value} dark:text-white`}>{measurementUnit}</span>
              </div>
              <div className={styles.field}>
                <span className={styles.labels}>Geo-Fencing Radius</span>
                <span className={`${styles.value} dark:text-white`}>{geoFencingRadius}</span>
              </div>
              </>
            )}
          </CardContent>
        )}
      </Card>
    );
};
